

const baseUrl = 'https://myaha.ai'
// const baseUrl = 'http://dev.myaha.ai'


// "prompt": "", // string 提示词
// "model": "", // string flux_pro|flux_schnell
export async function signatureGenerate(fingerprint, data) {
    return fetch(baseUrl + '/api/signature/generate_image', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'User-ID': fingerprint
        },
        body: JSON.stringify(data)
    }).then((data) => data.json())
}

export async function getCredits(fingerprint) {
    return fetch(baseUrl + '/api/style_transfer/get_credits', {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            'User-ID': fingerprint
        }
    }).then((data) => data.json())
        .then((data) => {
            return data.result?.credits || 0
        })
        .catch((error) => {
            console.error('getCredits:', error)
        })
}

export async function shareReport(fingerprint) {
    return fetch(baseUrl + '/api/style_transfer/share_report', {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            'User-ID': fingerprint
        }
    }).then((data) => data.json())
}

export async function uploadFile(formData) {
    return fetch(baseUrl + '/api/style_transfer/upload_image', {
        method: 'POST',
        body: formData
    })
        .then((response) => {
            return response.json()
        })
        .catch((error) => {
            console.error('Error uploading file:', error)
        })
}

export async function generateImage(fingerprint, data) {
    return fetch(baseUrl + '/api/style_transfer/generate_image', {
        method: 'POST',
        mode: 'cors',
        headers: {
            'Content-Type': 'application/json',
            'User-ID': fingerprint
        },
        body: JSON.stringify(data)
    }).then((data) => data.json())
}

export async function getGenerateResult(
    fingerprint,
    task_id,
    model,
    interval,
    totalTimeout,
    callback
) {
    let timeOut = false
    function inner() {
        return fetch(`${baseUrl}/api/signature/get_image?task_id=${task_id}&model=${model}`,
            {
                method: 'GET',
                mode: 'cors',
                headers: {
                    'Content-Type': 'application/json',
                    'User-ID': fingerprint
                }
            }
        )
    }

    function poll() {
        if (timeOut) {
            callback(null, null)
            return
        }
        inner()
            .then((data) => data.json())
            .then((data) => {
                let result_url = data.result?.image_url
                if (result_url) {
                    callback(null, result_url)
                    return result_url
                }
                setTimeout(poll, interval)
            })
            .catch((error) => {
                console.error('Error uploading file:', error)
                callback(error, null)
            })
    }
    setTimeout(() => {
        timeOut = true // 标记为已超时
        callback(null, null) // 超时时调用callback，传递null作为结果
    }, totalTimeout)
    poll()
}
